import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../App.module.css';
import MonthlyFeatureList from '../components/FeatureLists/MonthlyFeatureList';
import AnnualFeatureList from '../components/FeatureLists/AnnualFeatureList';
import { useChat } from '../context/ChatContext';
import { API_BASE } from '../api/config';

const CheckoutReturn = ({ theme }) => {
  const { user: contextUser } = useChat();
  const location = useLocation();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState('Friend');
  const [userId, setUserId] = useState(null);
  const [email, setEmail] = useState(null);
  const [accessLevel, setAccessLevel] = useState('active');

  useEffect(() => {
    let localUser = {};
    try {
      const stored = localStorage.getItem('daisy-user');
      if (stored) localUser = JSON.parse(stored);
    } catch (err) {
      console.error('⚠️ Failed to parse daisy-user:', err);
    }

    const user = contextUser || localUser;

    setFirstName(location.state?.first_name || user.first_name || 'Friend');
    setUserId(location.state?.user_id || user.id || null);
    setEmail(location.state?.user_email || user.email || null);
    setAccessLevel(location.state?.access_level || user.access_level || 'active');
  }, [location.state, contextUser]);

  const monthlyPriceId = process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID;
  const annualPriceId = process.env.REACT_APP_STRIPE_ANNUAL_PRICE_ID;

  const handleCheckout = async (priceId) => {
    try {
      const token = JSON.parse(localStorage.getItem('daisy-user'))?.token;
      const res = await fetch(`${API_BASE}/api/stripe/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, priceId, userId }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        console.warn('⚠️ No Stripe URL returned');
      }
    } catch (err) {
      console.error('🚫 Checkout failed:', err);
    }
  };

  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>🔁 {firstName}, you didn’t finish checking out</h1>
        <p style={{ marginBottom: '1.5rem' }}>
          {accessLevel === 'expired' ? (
            <>Your <strong>14-day trial has ended</strong>. Subscribe to regain access and continue your journey with dAIsy.</>
          ) : (
            <>Looks like you returned from checkout early — but your free trial is still active!</>
          )}
        </p>

        <div style={{ border: '1px solid #ddd', padding: '1rem', marginBottom: '2rem', borderRadius: '8px' }}>
          <h3>💬 Monthly Plan – $9.99/month</h3>
          <MonthlyFeatureList />
          <button className={styles.primaryButton} onClick={() => handleCheckout(monthlyPriceId)}>
            Subscribe Monthly
          </button>
        </div>

        <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '8px' }}>
          <h3>🌻 Annual Plan – $99/year</h3>
          <AnnualFeatureList />
          <button className={styles.primaryButton} onClick={() => handleCheckout(annualPriceId)}>
            Subscribe Annually
          </button>
        </div>

        {accessLevel !== 'expired' && (
          <p style={{ marginTop: '2rem' }}>
            👉 <strong>Want to keep exploring?</strong>{' '}
            <span
              onClick={() => navigate('/chat')}
              style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Continue your trial
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default CheckoutReturn;
